import styled from "styled-components";

const StyledGymSearch = styled.div`
	background-color: ${({ theme }) => theme.colors.black};
	* {
		font-family: "Inter", sans-serif;
	}
	.clash-display {
		font-family: "Clash Display", sans;
		font-weight: 500;
	}
	.sb-button__inner {
		padding: 0 10px;
		font-size: 16px;
		white-space: nowrap;
	}
	.sb-button {
		min-width: 100px;
	}
	.primary-filled--branding-primary-color {
		width: 220px;
	}
	.sb-header {
		@media (max-width: 575px) {
			flex-direction: column;
			gap: 16px;
			align-items: center;
		}
	}
	.orange-btn {
		background-color: #f95c25;
		color: #ffffff;
		font-size: 16px;
	}
	.transparent-btn {
		background-color: transparent;
		border: 1px solid;
		color: #f95c25;
		font-size: 16px;
	}
	.sb-gym-search {
		&__main-section {
			background-size: cover;
			background-position: center;
			display: flex;
			flex-direction: column;
			position: relative;
			min-height: 100vh;
			&::before {
				content: "";
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				background: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 1));
			}

			&__header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 20px 80px 0 80px;
				z-index: 3;
				flex-wrap: wrap;

				@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
					justify-content: center;
				}
				.actions {
					@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
						display: none;
					}
					button {
						width: max-content;
						min-width: auto;
					}
				}
			}
			&__footer {
				@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
					padding: 16px 32px;
				}
				z-index: 3;
				padding: 30px 60px;
				display: flex;
				flex-direction: column;
				align-items: center;
				gap: 24px;

				.divider {
					border-color: #1f1f1f;
				}
				.copyright {
					color: #d9d9d9;
					font-size: 14px;
				}
			}
		}

		&__actions {
			&__find-gym-button {
				display: flex;
				align-items: center;
				justify-content: center;
				background-color: transparent;
				border: none;
				gap: 12px;
				color: ${({ theme }) => theme.colors.coral};
				cursor: pointer;
				text-transform: uppercase;
			}
		}

		&__search {
			z-index: 3;
			padding: 32px;
			display: flex;
			align-items: center;
			justify-content: center;
			min-height: calc(100vh - 217px);
			background-size: cover;

			.title {
				@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
					font-size: 40px;
				}
				font-size: 80px;
				color: white;
			}

			.subtitle {
				font-size: 24px;
				font-weight: 300;
				color: white;
				@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
					font-size: 16px;
				}
			}

			&__inner {
				margin-top: 110px;
				width: 100%;
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				flex-direction: column;
				gap: 40px;
				font-size: 16px;

				&__header {
					display: flex;
					flex-direction: column;
					gap: 32px;
					text-align: center;
					align-items: stretch;

					&__input {
						border-radius: 100px;
						width: 610px;
						padding: 2px;
						background: ${({ theme }) => theme.colors.white};

						.sb-form-input {
							height: 36px;

							&:first-child {
								border-right: 2px solid rgba(0, 0, 0, 0.1);

								.ant-form-item {
									width: 100%;
								}
							}
						}

						.ant-form-inline {
							flex-wrap: nowrap;
							display: flex;
							align-items: center;
							justify-content: center;

							.ant-form-item {
								margin: 0;

								.ant-input {
									border: none;

									&:focus {
										border: none;
										outline: none;
										box-shadow: none;
									}
								}
							}
						}
					}
				}

				&__result {
					display: flex;
					flex-direction: column;
					gap: 8px;
					max-width: 400px;
					width: 100%;
					overflow: auto;
					max-height: 332px;

					.sb-information-card--transparent,
					.sb-information-card__body__header {
						color: ${({ theme }) => theme.colors.white};
					}

					.sb-information-card__body__text {
						opacity: 0.75;
					}
				}
			}
		}
	}

	.ant-input-group-wrapper-outlined .ant-input-group-addon {
		background: #f9fafb;
		padding-right: 8px;
		.orange-btn {
			border-color: #f95c25;
		}
	}
	.ant-input-outlined {
		border: none;
		box-shadow: none;
	}
	.ant-input-outlined:hover {
		border-color: #f9fafb;
		border: none;
		box-shadow: none;
	}
	input {
		height: 48px;
	}
`;

export default StyledGymSearch;
